import react from 'react';
import '../styling/SignUp.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Password = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // 1. Extract resetToken and userType passed from VerificationCode.js
  const { email, userType, resetToken } = location.state || {};

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // 2. Security Check: If someone tries to access this page directly without a token, kick them out
  useEffect(() => {
    if (!resetToken) {
      alert("Unauthorized access. Please verify your code first.");
      navigate('/forgotPassword'); // or /login
    }
  }, [resetToken, navigate]);

  const isPasswordValid = (password) => {
    const minLength = /.{8,}/;
    const lowercase = /[a-z]/;
    const uppercase = /[A-Z]/;
    const numberOrSymbol = /[\d\W]/;

    return (
      minLength.test(password) &&
      lowercase.test(password) &&
      uppercase.test(password) &&
      numberOrSymbol.test(password)
    );
  };

  const handleSubmit = async () => {
    if (!password || !confirmPassword) {
      alert("All fields are required.");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    if (!isPasswordValid(password)) {
      alert("Password must follow given requirements");
      return;
    }

    try {
      // 3. Dynamic Endpoint Selection
      const endpoint = userType === 'client' 
        ? `${process.env.REACT_APP_API_URL}/client-user/reset-client-password`
        : `${process.env.REACT_APP_API_URL}/business-user/reset-password`;

      // 4. Send the TOKEN instead of the email
      await axios.post(endpoint, {
        resetToken: resetToken, // Authentication
        newPassword: password   // Data
      }, { withCredentials: true });

      alert("Password changed successfully.");
      navigate("/login");

    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Failed to reset password. Session may have expired.");
      // If token expired, send them back to start
      navigate('/forgotPassword');
    }
  };

  // If no token, return null (prevents flash of content before useEffect redirect)
  if (!resetToken) return null;

  return (
    <div className='login' style={{ height: "530px", marginTop: "80px" }}>
      <div style={{ padding: '8%' }}>

        <div style={{ fontSize: "25px", color: "#1C1154", textAlign: "center", display: "block", fontWeight: "bold", marginBottom: "20px" }}>
          Enter New Password
        </div>

        {/* I corrected the inputs below. The first input is now 'password' */}
        <input
          placeholder="  Password"
          type="password"
          style={{
            border: "hidden",
            border: "1px solid #D9D9D9",
            fontSize: "15px",
            width: "100%",
            height: "50px",
          }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <div>
          <p style={{ color: '#625C73', fontWeight: '500' }}>Password Requirements:</p>
          <li style={{ listStyleType: 'circle', color: '#625C73', fontWeight: '350', paddingBottom: '2px' }}>At least 8 characters</li>
          <li style={{ listStyleType: 'circle', color: '#625C73', fontWeight: '350', paddingBottom: '2px' }}>One lowercase letter</li>
          <li style={{ listStyleType: 'circle', color: '#625C73', fontWeight: '350', paddingBottom: '2px' }}>One uppercase letter</li>
          <li style={{ listStyleType: 'circle', color: '#625C73', fontWeight: '350', paddingBottom: '2px' }}>One number or symbol</li>
        </div>

        {/* The second input is now 'confirmPassword' */}
        <input
          placeholder="  Confirm Password"
          type="password"
          style={{
            border: "hidden",
            border: "1px solid #D9D9D9",
            fontSize: "15px",
            width: "100%",
            height: "50px",
            marginTop: '10px'
          }}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <button
          style={{
            marginTop: "35px",
            height: "40px",
            width: "100%",
            background: "#260F99",
            border: "1px solid #43425D ",
            color: "#FFFFFF",
            fontSize: "17px",
            fontWeight: "450",
          }}
          onClick={handleSubmit}
        >
          Next &gt;
        </button>
        
        <div style={{ paddingLeft: '30%', color: '#545454' }}>
          <p> Go Back to <Link to="/login"><span style={{ textDecoration: 'underline' }}>login page</span></Link></p>
        </div>
      </div>
    </div>
  );
};

export default Password;